import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {Company} from 'main/stores/users';

class OktaCredentials extends DomainObject {
  domain;
  secret;
  clientId;
  company;

  _relations = {
    company: Company
  };

  constructor(other) {
    super();

    makeObservable(this, {
      domain: observable,
      secret: observable,
      clientId: observable,
      company: observable
    });

    this.merge(other);
  }
}

export default OktaCredentials;
